import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var MobileIcon = function MobileIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "MobileIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.942 3.667c0-.953.772-1.725 1.725-1.725h4.667c.952 0 1.725.772 1.725 1.725v8.666c0 .953-.773 1.725-1.725 1.725H5.667a1.725 1.725 0 0 1-1.725-1.725zm1.725-.275a.275.275 0 0 0-.275.275v8.666c0 .152.123.275.275.275h4.667a.275.275 0 0 0 .275-.275V3.667a.275.275 0 0 0-.275-.275h-.945a.725.725 0 0 1-.723.666H7.333a.725.725 0 0 1-.723-.666zm3.058 7.941a.725.725 0 0 0-1.45 0v.007a.725.725 0 0 0 1.45 0z",
      clipRule: "evenodd"
    })
  }));
};

export { MobileIcon };
